<template>
  <router-view />
</template>

<script setup>
import { useMeta } from 'quasar'

defineOptions({ name: 'App' })

useMeta({
  title: 'Home',
  titleTemplate: title => `${title} | Nave Contratos`
})
</script>
